module.exports = __webpack_public_path__ + "static/img/qiyekuaizhao.29be62c3.png";